module.exports = __webpack_public_path__ + "static/media/mylistmechiron.00fbc6e1.svg";